import axios from 'axios'
import { Mutex } from 'async-mutex'
import { asyncDebounce } from '@weblite/logic-toolkit'
import { getClientUserIdentityToken } from '$logic/auth'
import { OnboardingAction } from './types'
import { TOUR_API_URL } from '$config/env'

const getOnboardingActionsReqMutex = new Mutex()
let cachedResponse: OnboardingAction[]
export async function getOnboardingActionsReqBase(
  actionNames: string[],
): Promise<OnboardingAction[]> {
  const token = await getClientUserIdentityToken()

  return getOnboardingActionsReqMutex.runExclusive(() => {
    if (cachedResponse) return cachedResponse

    return axios
      .get<any, { data: OnboardingAction[] }>(
        new URL('tour', TOUR_API_URL).toString(),
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            action: [...actionNames],
          },
        },
      )
      .then(response => {
        cachedResponse = response.data
        return response.data
      })
  })
}

export const getOnboardingActionsReq = asyncDebounce(
  getOnboardingActionsReqBase,
  2000,
  {
    onlyResolveLast: true,
  },
)

export async function setOnboardingActionsReq(
  actionNames: string[],
): Promise<void> {
  const token = await getClientUserIdentityToken()
  const actions = actionNames.map(actionName => ({
    action: actionName,
    time: new Date(),
  }))

  return axios.post(new URL('tour', TOUR_API_URL).toString(), actions, {
    headers: { Authorization: `Bearer ${token}` },
  })
}
